import axios from 'axios'
import { API_ADDRESS } from 'config'
import { Building } from './types'

export const getBuilding = async (buildingId: string): Promise<Building> => {
  const url = `${API_ADDRESS}/building?buildingId=${buildingId}`
  const { data } = await axios.get(url)
  return data
}
